import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { ToastrService } from 'ngx-toastr';
import { JockeysService } from '../../services/jockeys.service';
import { EventsService } from '../../services/events.service';
import { AddEditEnquiryComponent } from '../modals/actions/add-edit-enquiry/add-edit-enquiry.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-jockey',
  templateUrl: './jockey.component.html',
  styleUrls: ['./jockey.component.scss']
})
export class JockeyComponent implements OnInit {

  meta: {
    loading: boolean,
    saving: boolean,
    selectedTab: string
  };
  jockey: any;

  constructor(
    private notification: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private jockeysService: JockeysService,
    private eventsService: EventsService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.meta = {
      loading: false,
      saving: false,
      selectedTab: 'enquiries'
    };

    this.eventsService.changeFixtureData({courseName: null});

    this.route.params.subscribe(params => {
      if (Object.keys(params).length) {
        this.jockey = {
          jockeyId: this.route.snapshot.paramMap.get('jockeyId')
        };
        this.getJockeyInfo(this.jockey.jockeyId);
        if (params.tab) {
          this.selectTab(params.tab);
        }
      }
    });
  }

  getJockeyInfo = (jockeyId) => {
    this.meta.loading = true;
    this.jockeysService.getJockeyInfo(this.jockey).subscribe(
      res => {
        this.jockey = res;
        this.jockey.address = this.jockey.address ? this.jockey.address.replace(/\|/g, ', ') : this.jockey.address;
        this.meta.loading = false;
      },
      err => {
        this.notification.error(`Could't get the Jockey Details: ${this.eventsService.getApiErrorMessage(err)}`, 'Error!');
        this.meta.loading = false;
        if (err.status === 401) {
          this.router.navigate(['/logout']);
        }
      }
    );
  }

  openAddEnquiry = (entry) => {
    const possibleOffenders = [
      {
        id: entry.jockeyId,
        knownAs: entry.jockeyKnownAs || entry.knownAs,
        type: 'jockey',
        jockeyMasterId: entry.jockeyMasterId || entry.masterId,
        jockeyMasterName: entry.jockeyMasterName || entry.masterName,
        jockeyMasterInvolved: false
      }
    ];
    const enquiry = {
      // meta: { year: moment().year(), raceId: null, divisionSequence: null, horseId: null },
      offender: possibleOffenders[0]
    };
    const modalWindow = this.modalService
    .open(AddEditEnquiryComponent, { centered: true, backdrop: 'static', size: 'lg'});
    modalWindow.componentInstance.enquiry = enquiry;
    modalWindow.componentInstance.possibleOffenders = possibleOffenders;
    modalWindow.result.then((result) => {
      this.selectTab('enquiries', true);
    }, (reason) => {
      // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
    });
  }

  selectTab = (tabName, force = false) => {
    this.location.replaceState(`/jockeys/${this.jockey.jockeyId}/${tabName}`);
    this.meta.selectedTab = tabName;
    if (this.meta.selectedTab === 'enquiries' && tabName === 'enquiries' && force === true) {
      this.eventsService.changeGenericEnquiry(true);
    }
  }

  enquiriesReloaded(value) {
    this.eventsService.changeGenericEnquiry(!value);
  }

}
